import React from 'react'
import { Text as OriginalText } from '../common'

const Text = ({ text, size = 9, noWrap = false, ...props }) => (
  <OriginalText size={size} text={text} nowrap={noWrap} {...props} />
)

export default Text
